import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const Background = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  display: flex;
  background: linear-gradient(to right, #0402fd 0%, #f4111b 100%);
  margin-bottom: 1rem;

  @media ${breakpoints.tablet} {
    height: 445px;
    background: linear-gradient(
      to right,
      #0402fd 0%,
      #f4111b 51%,
      transparent 50%,
      transparent 100%
    );
    margin-bottom: 3rem;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const LeftSection = styled.div`
  position: relative;
  width: 100%;
  padding-top: 140px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 455px;

  @media ${breakpoints.tablet} {
    width: 50%;
    padding: 60px 0;
  }

  & h1 {
    font-family: Geomanist;
    font-weight: 500;
    font-size: 26px;
    line-height: 26px;
    max-width: 230px;
    padding-left: 18px;

    @media ${breakpoints.tablet} {
      font-size: 39px;
      line-height: 43px;
      max-width: 455px;
      padding-left: 0;
    }

    @media ${breakpoints.desktopLarge} {
      font-size: 55px;
      line-height: 65px;
    }
  }

  & p {
    color: white;
    font-family: Geomanist;
    font-weight: 100;
    font-size: 14px;
    line-height: 18px;
    max-width: 230px;
    margin-top: 10px;
    padding-left: 10px;

    @media ${breakpoints.tablet} {
      max-width: 455px;
      padding-left: 0;
    }

    @media ${breakpoints.desktopLarge} {
      font-size: 20px;
      line-height: 28px;
    }
  }
`;

export const RightSection = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 30%;
  overflow: hidden;
  z-index: 0;
  background: white;

  @media ${breakpoints.tablet} {
    width: 50%;
    height: 100%;
  }
`;

export const StyledImage = styled.div<{ position: number }>`
  position: absolute;
  left: ${({ position }) => `${position * 33.33}%`};
  width: 33.33%;
  height: 100%;
  background-size: cover;
  background-position: center center;
`;

export const CenterCharacter = styled.div`
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: flex-end;
  left: 46%;
  bottom: -12px;
  transform: translateX(-50%);
  right: auto;

  @media ${breakpoints.desktopMax} {
    display: none;
  }

  img {
    width: auto;
    max-height: 170px;

    @media ${breakpoints.tablet} {
      height: auto;
      max-height: none;
    }
  }
`;

export const MobileImage = styled.div`
  position: absolute;
  right: 0;
  bottom: 24.5%;
  z-index: 10;
  display: flex;
  align-items: flex-end;

  @media ${breakpoints.tablet} {
    display: none;
  }

  img {
    width: auto;
    max-height: 170px;
  }
`;

export const StyledPostcodeSearch = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-start;
  max-width: 455px;

  @media ${breakpoints.desktopLarge} {
    margin-top: 2rem;
  }

  form {
    width: 100%;
  }
`;
